const GET_REPORT_LIST = 'GET_REPORT_LIST';
const SET_REPORT_LIST = 'SET_REPORT_LIST';
const SAVE_LINK = 'SAVE_LINK';
const IS_LINK_SAVED = 'IS_LINK_SAVED';
const DELETE_LINK = 'DELETE_LINK';
const SAVE_CATEGORY = 'SAVE_CATEGORY'
const SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA = 'SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA';
const GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA = 'GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA';

export {
    GET_REPORT_LIST,
    SET_REPORT_LIST,
    SAVE_LINK,
    IS_LINK_SAVED,
    DELETE_LINK,
    SAVE_CATEGORY,
    SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA,
    GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA
};
